import "./track.css";

export type VerticalItem = { title: string; text: string };

type VerticalTrackProps = {
  items: VerticalItem[];
  tone?: "light" | "dark";
};

/** Vertical version of the track: a navy rail beside each item, last segment coral. */
const VerticalTrack = ({ items, tone = "light" }: VerticalTrackProps) => (
  <ol className={`is-vtrack is-vtrack--${tone}`}>
    {items.map((item, i) => {
      const last = i === items.length - 1;
      return (
        <li key={item.title} className="is-vtrack__item">
          <span
            className={"is-vtrack__rail" + (last ? " is-vtrack__rail--accent" : "")}
            aria-hidden="true"
          />
          <div className="is-vtrack__body">
            <span className={"is-vtrack__num" + (last ? " is-vtrack__num--accent" : "")}>
              {String(i + 1).padStart(2, "0")}
              {last ? " ↺" : ""}
            </span>
            <h3 className="is-vtrack__title">{item.title}</h3>
            <p className="is-vtrack__text">{item.text}</p>
          </div>
        </li>
      );
    })}
  </ol>
);

export default VerticalTrack;
